<template>
  <div class="content">
    <topWell :showNews="false" />
    <div class="mainBox">
      <listNav v-if="pageType!=='djgz'" :title="pageTitle" :navData="classData" @checkPageInd="checkPageInd"/>
      <div class="list">
        <dataNone v-if="list.length<=0"></dataNone>
        <div class="item" v-else :style="pageType==='zcfg'?'padding: 40px 17px;':''" v-for="v of list" :key="v.id" @click="jumpDet(v)">
          <div class="item-left" :style="pageType==='djgz'?'order: 2;':''">
            <img :src="pageType==='djgz'||pageType==='gkgs'?v.ossUrl:v.coverOssUrl" alt="" class="img" v-if="pageType!=='zcfg'"/>
            <div class="date" style="font-weight: bold;" v-else>{{ v.createTime ? v.createTime.substring(10, 0) : "" }}</div>
          </div>
          <div class="item-right" :style="pageType==='djgz'?'order: 1;margin-left:0;margin-right: 30px;':''">
            <div class="title">
              {{ v.title }}
            </div>
            <div class="date" v-if="pageType==='xwzx'||pageType==='gkgs'">
              {{ v.createTime ? v.createTime.substring(10, 0) : "" }}
            </div>
            <div class="des">
              {{ pageType==='xwzx'?v.remark:v.sketch }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="page"
        style="display: flex; justify-content: center; margin-bottom: 100px"
      >
        <pagination
          v-show="pageInfo.pageTotal > 0"
          :total="pageInfo.pageTotal"
          :page.sync="pageInfo.pageNum"
          :limit.sync="pageInfo.pageSize"
          @pagination="getData"
        />
        <!--        <el-pagination-->
        <!--          background-->
        <!--          layout="total, sizes, prev, pager, next, jumper"-->
        <!--          :total="pageInfo.pageTotal"-->
        <!--          :page.sync="pageInfo.pageNum"-->
        <!--          :limit.sync="pageInfo.pageSize"-->
        <!--          @pagination="getData"-->
        <!--        >-->
        <!--        </el-pagination>-->
      </div>
    </div>
    <bottomNav />
  </div>
</template>

<script>
import topWell from "@/views/topWheel/topWheel.vue";
import bottomNav from "@/views/bottomNav/bottomNav.vue";
import { htmlSplice } from "../../../utils/common.js";
import pagination from "../../components/pagination.vue";
import listNav from "../../components/listNav.vue";
import dataNone from "../../components/dataNone.vue";
export default {
  components: {
    topWell,
    bottomNav,
    pagination,
    listNav,
    dataNone
  },
  data() {
    return {
      pageType: this.$route.query.type,
      list: [], //列表数据
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
        pageTotal: 2,
      },
      classData: [], // 新闻分类
      pageInd: 0,
      classValue: 1,
      pageTitle: '',
      pageLoading: false
    };
  },
  watch: {
    $route() {
      // 监听路由变化并检查
      this.checkRouteForProject();
    },
  },
  created() {
    // console.log(this.pageType);
    this.checkRouteForProject()
  },
  methods: {
    // 跳转新闻详情
    jumpDet(v) {
      var pageName = this.pageType === 'djgz' ? '' : this.classData[this.classValue-1].dictLabel
      this.$router.push({ path: "/articleDet", query: {
          pageType: this.pageType,
          pageName,
          ...v
        } });
    },
    checkRouteForProject() {
      this.pageType = this.$route.query.type;
      this.classValue = 1
      if(this.pageType==='xwzx'){
        this.pageTitle = '新闻中心'
      }
      if(this.pageType==='gkgs'){
        this.pageTitle = '公示公告'
      }
      if(this.pageType==='zcfg'){
        this.pageTitle = '政策法规'
      }
      if(this.pageType==='djgz'){
        this.pageTitle = '党建工作'
      }
      this.getPressClassifyData();
      this.getData();
    },
    checkPageInd(v, ind) {
      this.pageInd = ind;
      this.classValue = v.dictValue;
      this.getData();
    },
    // 获取新闻分类
    getPressClassifyData() {
      if (this.pageType === "xwzx") {
        this.$api.getPressClassifyApi().then((res) => {
          this.classData = res.data;
        });
      }
      if (this.pageType === "gkgs")  {
        this.$api.getAnnouncementClassifyApi().then((res) => {
          this.classData = res.data;
        });
      }
      if (this.pageType === "zcfg")  {
        this.$api.getProjectClassify().then((res) => {
          this.classData = res.data;
        });
      }
    },
    // 获取新闻列表
    getData(classify) {
      this.pageLoading = false
      classify = this.classValue;
      if (this.pageType === "xwzx") {
        this.$api
          .getpressCenterApi({
            classify: classify || "",
            ...this.pageInfo,
          })
          .then((res) => {
            this.list = res.rows;
            this.list = this.list.filter((v) => {
              v.content = htmlSplice(v.content);
              return v;
            });
            this.pageInfo.pageTotal = res.total;
            this.pageLoading = true
          });
      }
      if(this.pageType==='gkgs'){
        this.$api.getAnnouncementApi({
            classify: classify || "",
            ...this.pageInfo,
          }).then((res) => {
          this.list = res.rows;
          this.list = this.list.filter((v) => {
            v.content = htmlSplice(v.content);
            return v;
          });
          this.pageInfo.pageTotal = res.total;
          this.pageLoading = true
        });
      }
      if(this.pageType==='djgz'){
        this.$api.getPartyBuilding(this.pageInfo).then(res=>{
          this.list = res.rows;
          this.list = this.list.filter((v) => {
            v.content = htmlSplice(v.content);
            return v;
          });
          this.pageInfo.pageTotal = res.total;
          this.pageLoading = true
        })
      }
      if(this.pageType==='zcfg'){
        this.$api.getpolicyList({
          classify: classify || "",
          ...this.pageInfo,
        }).then(res=>{
          this.list = res.rows;
          this.list = this.list.filter((v) => {
            v.content = htmlSplice(v.content);
            return v;
          });
          this.pageInfo.pageTotal = res.total;
          this.pageLoading = true
        })
      }
    },
  },
};
</script>
<style scoped lang="less">
.mainBox {
  font-family: "思源黑体";
  // margin-top: 90px;
  box-sizing: border-box;
  width: 93.75rem /* 1500/16 */;
  margin: 0 auto;
  .list {
    padding: 70px 6.5rem /* 104/16 */;
    min-width: 93.75rem /* 1500/16 */;
    .item {
      border-bottom: 1px solid #ececec;
      padding: 30px 17px;
      display: flex;
      align-items: center;
      cursor: pointer;
      &:hover {
        transition: 0.5s;
        background: rgb(244, 245, 250);
        .item-right .title {
          color: #1e439b;
        }
      }

      .item-left {
        width: 320px;
        .img {
          width: 320px;
        }
      }
      .item-right {
        width: calc(100% - 350px);
        margin-left: 30px;
        .title {
          font-size: 20px;
          font-weight: bold;
          color: #333;
          width: 100%;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        .date {
          margin-top: 30px;
          font-size: 18px;
          color: #666;
        }
        .des {
          margin-top: 30px;
          font-size: 16px;
          color: #999;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2; /* 显示的行数，可以根据需要修改 */
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #1e439b;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #1e439b;
  cursor: pointer;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active,
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active:hover {
  color: #fff;
}
</style>
